<template>
  <div>
    <ThePageHeader :title="'Adatvédelmi nyilatkozat'" />

    <div class="maximize">
      <p class="mt-5">
        A Körös PRINT-PACK Kft., a print-pack.hu tulajdonosa kiemelt figyelmet fordít
        a látogatók adatainak biztonságos kezelésére.
        Cégünk vállalja, hogy minden esetben a hatályos hazai törvények szerint
        jár el az adatkezelésben (jelenleg
        az információs önrendelkezési jogról és az információszabadságról
        szóló 2011. évi CXII. törvény).
        Az adatokat bizalmasan kezeljük, harmadik félnek nem továbbítjuk azokat.
        A weboldal használatával Ön hozzájárul, hogy az így keletkezett
        adatokat felhasználjuk az oldal üzemeltetéséhez,
        fejlesztéséhez, promóciós- és egyéb marketingtevékenységekhez.
        A Körös PRINT-PACK Kft. fenntartja a jogot jelen adatvédelmi nyilatkozat
        megváltoztatására.
      </p>

      <p><b>Adatkezelő elérhetőségei:</b></p>

      <p>
        Körös PRINT-PACK Nyomdaipari Csomagolástechnikai Kft.<br>
        Cím: H-5600 Békéscsaba, Orosházi út 32.<br>
        Adószám: 10264175-2-04<br>
        Telefon: +3666447608<br>
        E-mail: info@print-pack.hu
      </p>

      <p><b>COOKIE-K (SÜTIK):</b></p>

      <p>
        A sütik segítségével információk gyűjthetők a print-pack.hu és aloldalainak
        (továbbiakban: print-pack.hu) látogatóiról és eszközeikről; megjegyzik a látogatók
        egyéni beállításait, amelyek felhasználásra kerül(het)nek.
        Ezen sütik lejáratukig a látogató böngészésre használt eszközén,
        annak böngészőjében maradnak, illetve amíg a látogató nem törli őket.
        Feltétlenül szükséges cookie-k: Ezen sütik célja, hogy a látogatók maradéktalanul
        és zökkenőmentesen böngészhessék a print-pack.hu-t, használhassák annak funkcióit,
        és az ott elérhető szolgáltatásokat.
        Harmadik féltől származó cookie-k:
      </p>

      <p>
        <ul>
          <li>
            Google Analytics: statisztikai célú szolgáltatás használatával információkat
            gyűjt azzal kapcsolatban, hogy a látogatók hogyan használják a print-pack.hu-t.
            Az adatot a honlap fejlesztésének és a felhasználói élmény javításának
            céljával használja fel.
            Honlapunk aktiváltatta az IP-címek anonimizálását, így az Analytics az
            Adatgyűjtő Hálózat lehető legkorábbi szakaszában anonimmá teszi a címet.
            Ezen sütik működésére a Google adatvédelmi irányelvei vonatkoznak
            ( <a
              href="https://support.google.com/analytics/answer/6004245?hl=hu"
              target="_blank"
            >
              https://support.google.com/analytics/answer/6004245?hl=hu
            </a> ).
          </li>
        </ul>
      </p>

      <p><b>Jogorvoslati lehetőséggel a következő hatóságnál lehet élni:</b></p>

      <p>
        Nemzeti Adatvédelmi és Információszabadság Hatóság<br>
        Cím: H-1125 Budapest, Szilágyi Erzsébet fasor 22/c<br>
        Posta cím: H-1530 Budapest, Pf.: 5<br>
        Telefon: +36 1 391 1400<br>
        Fax: +36 1 391 1410<br>
        E-mail: ugyfelszolgalat@naih.hu
      </p>

      <p>
        A weboldal használatával a felhasználó elfogadja jelen adatvédelmi nyilatkozatot.
      </p>
    </div>
  </div>
</template>

<script>
import ThePageHeader from '@/components/ThePageHeader.vue';

export default {
  name: 'PrivacyStatement',
  components: {
    ThePageHeader,
  },
  metaInfo: {
    title: 'Adatvédelmi nyilatkozat | Körös PRINT-PACK Kft.',
  },
};
</script>
